import { Card, CardBody, CardHeader, Heading, Box } from '@chakra-ui/react'
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface LineChartProps {
  title: string
  labels?: string[]
  data?: number[]
  color?: string
  isLoading?: boolean
}

export function LineChart({ title, labels = [], data = [], color = '#3182CE', isLoading = false }: LineChartProps) {
  const chartData = (labels || []).map((label, index) => ({
    label,
    value: (data || [])[index] || 0,
  }))

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Heading size="md">{title}</Heading>
        </CardHeader>
        <CardBody>
          <Box h="200px" display="flex" alignItems="center" justifyContent="center">
            Loading...
          </Box>
        </CardBody>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <Heading size="md">{title}</Heading>
      </CardHeader>
      <CardBody>
        <Box h="200px">
          <ResponsiveContainer width="100%" height="100%">
            <RechartsLineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.1} />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 12 }}
                angle={-45}
                textAnchor="end"
                height={60}
              />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="value"
                stroke={color}
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
                fill={color}
                fillOpacity={0.2}
              />
            </RechartsLineChart>
          </ResponsiveContainer>
        </Box>
      </CardBody>
    </Card>
  )
}

